<template>
  <div class="result-detail result" v-if="result">
    <Miniform class="mb-4" />
    <header class="page-header mb-3">
      <h1>{{ $lang.translate('track.header.shipmentFrom').replace('{0}', result.from.name) }}</h1>
      <p>{{ $lang.translate('track.label.trackingInformation') }}: {{ trackingNumber }}</p>
      <span class="label" :class="statusCode">
        {{ $lang.translate('track.label.status') }}: {{ statusText }}
      </span>
    </header>
    <Damages :damages="result.damages" v-if="result.damages.length" />
    <div class="result-details result-box bg-white has-shadow is-rounded">
      <div class="columns">
        <Sender :result="result" class="is-third" />
        <Recipient :result="result" class="is-third" />
        <Details :result="result" :expanded="true" class="is-third" />
      </div>
      <hr class="divider" />
      <StatusList v-if="result.orderStatuses" :maps="maps" :totalColli="result.details.totalColli" :statuses="result.orderStatuses" :packages="result.packages" />
      <hr class="divider" v-if="result.orderStatuses" />
      <PackageList v-if="result.packages.length" :maps="maps" :totalColli="result.details.totalColli" :packages="result.packages" :deliveredPackageIds="deliveredPackages" />
    </div>
  </div>
  <div v-else>
    <header class="page-header mb-3">
      <h1>{{ $lang.translate('track.header.notFound')}}</h1>      
    </header>
    <Miniform class="mb-4" />
  </div>
</template>

<script>
import { getters, store } from '@/store'
import Sender from '@/components/result/Sender'
import Recipient from '@/components/result/Recipient'
import Damages from '@/components/result/Damages'
import Details from '@/components/result/Details'
import StatusList from '@/components/result/StatusList'
import PackageList from '@/components/result/PackageList'
import Miniform from '@/components/Miniform'
import { dirtyUrlParam } from '@/utils'

export default {
  data () {
    return {
      result: null,
      maps: null
    }
  },
  computed: {
    results () {
      return store.results
    },
    trackingNumber () {
      return this.result.details.freightBillNo + ' - ' + this.result.details.senderReference
    },
    status () {
      if (this.result.orderStatuses.length > 0) {
        return this.result.orderStatuses[0]
      }
      return null
    },
    statusText () {
      if (this.statusCode == 'ontheway') {
        return this.status.statusText + ' (' + this.deliveredPackages.length + '/' + this.result.packages.length + ')'
      }
      return this.status.statusText
    },
    deliveredPackages() {
      return getters.deliveredPackages(this.result)
    },
    statusCode () {
      if (this.status) {
        if (this.status.status == 'delivered' && this.result.packages.length > 1) {
          return this.result.packages.length == this.deliveredPackages.length ? 'delivered' : 'ontheway'
        }
        return this.status.status
      }
      return 'unknown'
    }
  },
  methods: {
    setResult() {
      let result = null
      if (this.$route.params.id) {
        result = getters.getResultById(dirtyUrlParam(this.$route.params.id))       
      }
      this.result = result
    }    
  },
  async mounted () {
    this.setResult()
    
    if (this.$mapsEnabled) {
      const maps = await this.$loadMaps()
      this.maps = maps
    }
  },
  watch: {
    '$route.params.id'() {
      this.setResult()
    },
    'results'() {
      this.setResult()
    }
  },
  components: {
    Sender,
    Recipient,
    Damages,
    Details,
    StatusList,
    PackageList,
    Miniform
  }
}
</script>

<style>
hr.divider {
  border: none;
  border-bottom: 1px solid #D3D3D3;
  margin: 2rem 0;
}
</style>

<style scoped>
@media(min-width: 1024px) {
  .result-footer {
    align-items: flex-end;
  }
}

.download-box {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
</style>
